<template>
  <div class="create-page">
    <div class="header">
      <h1>Add a book</h1>
    </div>
    <div class="content panel">
      <p>
        If you have a lot of books to import, you can scan them directly onto a
        shelf.
      </p>
      <p>Scanning: {{ scanning }}</p>
      <p>Automatically add new books to:</p>
      <select v-model="targetShelf">
        <option
          v-for="shelf in shelves"
          :value="shelf.label"
          :key="shelf.label"
          >{{ shelf.description }}</option
        >
      </select>
      <button v-on:click="scanning = true">Scan</button>
    </div>
    <div class="content">
      <ul class="bookDetailsList">
        <li v-for="book in books" :key="book.guid" class="bookDetailsItem">
          <publication-details
            :publication="book"
            :user="user"
            :token="token"
          ></publication-details>
        </li>
      </ul>
      <v-quagga
        :onDetected="logIt"
        :readerSize="readerSize"
        :readerTypes="['ean_reader']"
      ></v-quagga>
    </div>
  </div>
</template>
<style>
video,
canvas {
  width: 320px;
  height: 240px;
}
video {
  filter: grayscale(1);
}
</style>
<script>
import axios from 'axios';
import PublicationDetails from '../components/PublicationDetails';

export default {
  name: 'create',
  components: {
    'publication-details': PublicationDetails,
  },
  data() {
    return {
      user: {},
      token: this.$cookies.get('user'),
      searchTerm: '',
      books: [],
      shelves: [],
      targetShelf: '',
      readerSize: {
        width: 64,
        height: 48,
      },
      detecteds: [],
      scanning: true,
    };
  },
  async mounted() {
    await this.getUser();
    this.getShelves();
  },
  methods: {
    logIt(data) {
      if (this.scanning) {
        this.scanning = false;
        axios
          .post(
            '/publications',
            {
              isbn: data.codeResult.code,
            },
            {
              headers: {
                Authorization: `Bearer ${this.token}`,
              },
            },
          )
          .then((response) => {
            if (response.data.length > 0) {
              this.books = this.books.concat(response.data);
              this.addPublicationToShelf(response.data[0].guid);
            } else {
              this.scanning = false;
            }
          });
      }
    },
    async getShelves() {
      if (this.user && this.token) {
        axios
          .get(`/user/${this.user.username}/shelves`, {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          })
          .then((response) => {
            this.shelves = response.data;
            this.targetShelf = this.shelves[0].label;
          });
      }
    },
    async getUser() {
      if (this.token) {
        axios
          .get('/user', {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          })
          .then((response) => {
            this.user = response.data;
          });
      }
    },
    onSubmit() {
      return axios
        .post(
          '/publications',
          {
            text: this.searchTerm,
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          },
        )
        .then((response) => {
          this.books = response.data;
        });
    },
    addPublicationToShelf(publicationId) {
      // console.log(`Adding: ${publicationId} to ${this.targetShelf}`);
      // return;
      return this.addPublicationToUser(publicationId)
        .then((bookData) => {
          this.addBookToShelf(bookData.data.guid);
        })
        .then((response) => {
          this.flashMessage.show({
            message: 'Book added to shelf',
          });
          console.log(response);
        });
    },
    addPublicationToUser(publicationId) {
      return axios.put(
        '/books',
        {
          publicationId,
        },
        {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        },
      );
    },
    addBookToShelf(bookId) {
      axios.put(
        `/user/${this.user.username}/shelf/${this.targetShelf}`,
        [bookId],
        {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        },
      );
    },
  },
};
</script>
